var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-3 mb-1 text-right"},[_c('button',{staticClass:"btn btn-vino-o",staticStyle:{"border-radius":"22px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.reload()}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Atrás")])])
}
var staticRenderFns = []

export { render, staticRenderFns }